<div class="kpi-box">
    <label class="title font-weight-bold">{{options.extraOptions.label}}</label>
    <p class="amount" title="{{numberData}}" [innerHtml]="options.data | safeHtml"></p>
</div>
